export default __webpack_public_path__ + "static/media/clothes-icon.0c705f68.svg";